import { NgModule } from "@angular/core";
import { PartnerComponent } from "./partner/partner.component";
import { PartnerPlatformRoutingModule } from "./partner-platform-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { SharedComponentModule } from "../share/component/shared-component.module";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { PartnerSaveComponent } from "./partner-save/partner-save.component";
import { MtxColorpickerModule } from "@ng-matero/extensions/colorpicker";
import { NgxMaskModule } from "ngx-mask";
import { PartnerDetailsComponent } from "./partner-details/partner-details.component";
import { AddBranchDialogComponent } from "./partner-details/add-branch-dialog/add-branch-dialog.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { CommonModule } from "@angular/common";
import { PartnerDetailsTableComponent } from "./components/partner-details-table/partner-details-table.component";
import { AddUserDialogComponent } from "./partner-details/add-user-dialog/add-user-dialog.component";
import { ImageViewerDialogComponent } from "./components/image-viewer-dialog/image-viewer-dialog.component";
import { AddProtectionDialogComponent } from "./partner-details/add-protection-dialog/add-protection-dialog.component";
import { DocumentCardComponent } from "./components/document-card/document-card.component";
import { NgxEditorModule } from "ngx-editor";
import {
  PartnerNavigationSidebarComponent
} from "./components/partner-navigation-sidebar/partner-navigation-sidebar.component";

@NgModule({
  declarations: [
    PartnerComponent,
    PartnerSaveComponent,
    PartnerDetailsComponent,
    AddBranchDialogComponent,
    PartnerDetailsTableComponent,
    AddUserDialogComponent,
    ImageViewerDialogComponent,
    AddProtectionDialogComponent,
    DocumentCardComponent,
    PartnerNavigationSidebarComponent
  ],
  imports: [
    CommonModule,
    PartnerPlatformRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    SharedComponentModule,
    NgxSkeletonLoaderModule,
    MtxColorpickerModule,
    NgxMaskModule,
    FlexLayoutModule,
    NgxEditorModule
  ]
})
export class PartnerPlatformModule {}
